import React from "react";
import { PulseLoader } from "react-spinners";


function Loader({ loading = false, text = "" }) {
  return (
    <>
      {loading === true ? (
        <div className="loader">
          <PulseLoader color="#ffffff" />
          {text && (
            <p>{text}</p>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export default Loader;